import React from 'react';
import PropTypes from 'prop-types';

const EffectCirclePath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M16 28C9.373 28 4 22.627 4 16S9.373 4 16 4s12 5.373 12 12-5.373 12-12 12zm0-3a9 9 0 1 0 0-18 9 9 0 0 0 0 18z"
    />
  );
};

EffectCirclePath.propTypes = {
  fill: PropTypes.string,
};

export default EffectCirclePath;



// WEBPACK FOOTER //
// ./src/icon/svgs/effects/effect-circle.jsx